export function blockLastestNews(){
    document.querySelectorAll('.lastest-news-block').forEach((container) => {
        const list = container.querySelector('.grid'),
            max_page = list.dataset.numberOfPages,
            formData = new FormData(),
            btn = container.querySelector('.load_more');

            if(!btn) return false;

            btn.addEventListener('click', (e) => {
                e.preventDefault();

                let current_page = list.dataset.currentPage;

                if(current_page === max_page) return false;

                formData.append('action', 'load_more_posts');
                formData.append('_wpnonce', ajax_object.wp_nonce);
                formData.append('current_page', current_page)

                fetch(ajax_object.ajax_url, {
                    method : "POST",
                    body : formData
                }).
                    then((res) => res.json())
                    .then((res) => {
                        list.setAttribute('data-current-page', res.data.current_page)
                        if(res.data.current_page === 1){
                            list.innerHTML = res.data.posts
                            btn.innerHTML = "Show more articles"
                        }else{
                            list.innerHTML += res.data.posts
                        }


                        if(res.data.current_page == max_page){
                            btn.innerHTML = "Show fewer articles"
                            list.setAttribute('data-current-page', 0)
                        }
                    })
            })

    })
}